<template>
  <BasePopup
    :show="show"
    :show-close-button="false"
    :auto-close="3000"
    @close="$emit('close')"
  >
    <div class="success-popup-content">
      <!-- 粉紅色 check 圖標 -->
      <div class="success-icon">
        <svg width="60" height="43" viewBox="0 0 60 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M56.6667 3L20 39.6667L3.33337 23" stroke="#FE577F" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- 成功訊息文字 -->
      <div class="popup-title">{{ message }}</div>
    </div>
  </BasePopup>
</template>

<script>
import BasePopup from '@/components/Page/Web/PartnerMarketing/BasePopup.vue'

export default {
  name: 'SuccessPopup',
  components: { BasePopup },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '操作成功！'
    }
  }
}
</script>

<style lang="scss" scoped>
.success-icon {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}
</style>